import { gql } from '@apollo/client';

export default gql`
  query priceBookProduct($partnerLocationId: ID!, $productId: ID!) {
    priceBookProduct(
      partnerLocationId: $partnerLocationId
      productId: $productId
    ) {
      id
      price
      showInStore
      overPrice
      productId
      product {
        id
        name
        price
        description
        description
        sku
        defaultSubscriptionRetainer
        productCategories {
          id
          name
        }
        featuredImage
        productRenewalInterval {
          id
          name
        }
        productFeatures {
          id
          text
        }
        productImages {
          id
          imageUrl
        }
        productType
        planSubscription {
          id
          name
        }
        planProducts {
          id
          overridePrice
          price
        }
      }
    }
  }
`;
